// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import CreateAlertTypeSelectorTemplate from '@front/templates/CreateAlertTypeSelectorTemplate.html';
import { ContainerControl } from '@front/controls/elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { AlertType, getAlertTypeKey } from '@shared/utils/Alert/AlertConstants';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { createContextMenuItemsFromEnum } from '@shared/utils/ContextMenuUtils';
export class CreateAlertTypeSelector extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'CreateAlertTypeSelector';
    }
    oninit() {
        super.oninit();
        this.repopulate();
        this.observe('selectedItem', this.updateAlertType);
        this.observe('value', this.updateAlertTypeValue);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    updateAlertType(selectedItem) {
        if (!isNullOrUndefined(selectedItem)) {
            void this.set({ value: selectedItem.value });
        }
    }
    updateAlertTypeValue(newV, oldV) {
        const items = this.get('items');
        if (!isValidArray(items)) {
            return;
        }
        for (let i = 0; i < items.length; i++) {
            if (items[i].value === newV) {
                void this.set({ selectedItem: items[i] });
                break;
            }
        }
    }
    localize() {
        void this.set('label', Resources.getResource('screen.Alerts.Label.AlertType'));
    }
    repopulate() {
        const items = this.get('items');
        const selectedItem = items[0];
        void this.set({ selectedItem });
    }
}
ContainerControl.extendWith(CreateAlertTypeSelector, {
    template: CreateAlertTypeSelectorTemplate,
    data: function () {
        return {
            label: '',
            instrument: null,
            items: createContextMenuItemsFromEnum(AlertType, getAlertTypeKey),
            selectedItem: null,
            value: -1,
            width: 198
        };
    }
});
